import { Loader2 } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { useMemberAuth } from "@/context/MemberAuthContext";
import { IMAGES } from "@/lib/content";
import AuthForms from "@/pages/membership/AuthForms";
import MemberDashboard from "@/pages/membership/MemberDashboard";

export default function MemberAccount() {
  const { member, ready } = useMemberAuth();

  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center bg-ptf-bg" data-testid="member-account-loading">
        <Loader2 className="h-6 w-6 animate-spin text-ptf-primary" />
      </div>
    );
  }

  return (
    <>
      <Seo title="My Account" description="Join Planet Trotter Foundation as a member to access Training and Volunteer opportunities." path="/account" />
      <PageHero
        eyebrow="Membership"
        titleLines={member ? ["My", "Account"] : ["Join Planet", "Trotter"]}
        intro={member ? "Manage your membership, profile and applications." : "One account for Learn, Train, Practice and Volunteer with Planet Trotter Foundation."}
        image={IMAGES.hero}
      />
      <section className="bg-ptf-bg py-16 md:py-24">
        <div className="mx-auto max-w-[900px] px-5 sm:px-8 lg:px-12">
          {!member ? <AuthForms /> : <MemberDashboard member={member} />}
        </div>
      </section>
    </>
  );
}
